/*  ========================================================================
    # Sections - Image Gallery - Index
    ========================================================================  */

import React from 'react';
import { createRoot, type Container } from 'react-dom/client';
import ImageGallery from './ImageGallery';

export type ImageGalleryProps = {
  headline: string;
  images: Array<{
    filename: string;
    filesize: number;
    mime_type: string;
    url: string;
    alt: string;
    caption: string;
    width: number;
    height: number;
    sizes: {
      'thumbnail': string;
      'thumbnail-width': number;
      'thumbnail-height': number;
      'medium': string;
      'medium-width': number;
      'medium-height': number;
      'medium_large': string;
      'medium_large-width': number;
      'medium_large-height': number;
      'large': string;
      'large-width': number;
      'large-height': number;
      '1536x1536': string;
      '1536x1536-width': number;
      '1536x1536-height': number;
      '2048x2048': string;
      '2048x2048-width': number;
      '2048x2048-height': number;
      'placeholder': string;
      'placeholder-width': number;
      'placeholder-height': number;
    };
  }>;
};

const containers = document.querySelectorAll('div[data-react-app="image-gallery"]');

for (let i = 0; i < containers.length; i++) {
  const containerGuid = (containers[i]?.attributes as any)['data-guid']?.value;
  const props = (window as any).reactProps[containerGuid] as ImageGalleryProps;

  createRoot(containers[i] as Container).render(<ImageGallery {...props} />);
}
